import React from 'react';
import classNames from 'classnames';
import styles from '../../index.module.scss';
import { Button } from '@mui/material';

export const RemoveAction = ({
  surgeryIndex,
  onRemove,
}: {
  surgeryIndex: number;
  onRemove(index: number): void;
}) => {
  return surgeryIndex == 0 ? null : (
    <Button
      variant={'text'}
      className={classNames(styles.actionBtn, styles.remove)}
      onClick={() => onRemove(surgeryIndex)}>
      Remove Surgery
    </Button>
  );
};
